import React, { useState, useEffect } from "react";
import home from "./Assets/Home.jpg";
import { NavLink } from "react-router-dom";
import ReactLoading from "react-loading";
import { Typewriter } from "react-simple-typewriter";
const Home = () => {
  const [isloading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // loading stop after 2 sec 
    }, 2000);
  });
  return (
    <>
      <div name="Home">
        <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20 lg:mt-5 md:mt-[7rem]">
          <div className="flex flex-col items-center justify-between lg:flex-row">
            <div className="mb-10 lg:max-w-lg lg:pr-5 lg:mb-0">
              <div className="max-w-xl mb-6 lg:mt-4">
                <h2
                  className="max-w-lg mb-6 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none font-sans"
                  data-aos="fade-up"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  Welcome to{" "}
                  <span className="text-3xl font-mono text-transparent bg-clip-text bg-gradient-to-r to-blue-500 from-sky-500">
                    <Typewriter
                      words={["MalakTel Auction .", "MalakTel Auction ."]}
                      loop={true}
                      cursor
                      cursorStyle="|"
                      cursorColor="skyblue"
                      typeSpeed={90}
                    />
                  </span>
                </h2>
                <p
                  className="text-base text-gray-700 md:text-lg"
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-once="true"
                >
                  Engage in live auctions ! Register your unique items for
                  auction or join our live video conference auctions to
                  participate and bid in real time.
                </p>
              </div>

              <div
                className="flex flex-col items-start md:flex-row"
                data-aos="fade-up"
                data-aos-duration="1100"
                data-aos-once="true"
              >
                <NavLink to="/learnmore">
                  {" "}
                  <a
                    href="/"
                    className="inline-flex items-center justify-center w-full h-12 bg-blue-500 px-6 mb-3 font-medium tracking-wide text-white rounded md:w-auto md:mr-4 md:mb-0 shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
                  >
                    <span className="mr-3"> Learn More</span>
                  </a>
                </NavLink>
              </div>
            </div>
            <div
              className="relative lg:w-[40rem]"
              data-aos="zoom-out"
              data-aos-delay="500"
              data-aos-once="true"
            >
              <img
                className="object-cover w-full h-56 rounded sm:h-96 md:h-96"
                src={home}
                alt="AuctionImg"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
